import * as React from 'react';

import { Route } from 'react-router';

import { DeliveryAddressModal } from 'components/address-modal';
import { DeliveryAddressModalProvider } from 'components/address-modal/delivery-address-modal.context';
import { createLazyRoutes } from 'components/layout/routes';
import { NoStoresDeliveryModal } from 'components/modal-no-delivery-stores';
import { Routes } from 'components/routes';
import { StoreStatus } from 'remote/api/restaurants';
import { relativeRoutes } from 'utils/routing';

import { useStoreLocatorView } from '../hooks/use-store-locator-view';

const LazyRoutes = createLazyRoutes({
  NoStoresOpenDeliveryModal: () =>
    import('components/modal-no-delivery-stores-open/no-stores-open-delivery-modal'),
});

interface IDeliveryRoutesProps {
  deliveryModalPath?: string;
  dismissAddressModalUrl: string;
  redirectUrl: string;
  deliveryNoModal?: boolean;
}

export const DeliveryRoutes: React.FC<IDeliveryRoutesProps> = ({
  deliveryModalPath = relativeRoutes.address,
  dismissAddressModalUrl,
  redirectUrl,
  deliveryNoModal,
}) => {
  const { currentStep, setCurrentStep, setEditedAddress } = useStoreLocatorView();

  return (
    <Routes>
      {!deliveryNoModal && (
        <Route
          path={deliveryModalPath}
          element={
            <DeliveryAddressModalProvider>
              <DeliveryAddressModal
                redirectUrl={redirectUrl}
                dismissAddressModalUrl={dismissAddressModalUrl}
                currentStep={currentStep}
                setCurrentStep={setCurrentStep}
                setEditedAddress={setEditedAddress}
              />
            </DeliveryAddressModalProvider>
          }
        />
      )}

      <Route path={relativeRoutes[StoreStatus.NO_DELIVERY]} element={<NoStoresDeliveryModal />} />

      {/* May not be currently used, but should be no-harm to leave in. */}
      <Route
        path={relativeRoutes[StoreStatus.CLOSED]}
        element={<LazyRoutes.NoStoresOpenDeliveryModal />}
      />
    </Routes>
  );
};
